'use client'

import { useEnvContext } from 'next-runtime-env'
import { usePathname, useRouter } from 'next/navigation'
import type { FC } from 'react'
import type { AppLayoutProps } from '../../components/AppLayout'

export type AppLayoutWithEnvsProps = Omit<AppLayoutProps, 'options'> & {
  options: Omit<Partial<AppLayoutProps['options']>, 'locale'> & {
    locale: AppLayoutProps['options']['locale']
  }
}

export const withEnvs = (AppLayout: FC<AppLayoutProps>) => {
  return ({ children, ...props }: AppLayoutWithEnvsProps) => {
    const envs = useEnvContext() as { [key: string]: string }

    const router = useRouter()
    const pathname = usePathname()

    return (
      <AppLayout
        {...props}
        router={{
          pathname,
          push: (path: string) => router.push(path),
          ...props.router,
        }}
        options={{
          baseDomain: envs.NEXT_PUBLIC_BASE_DOMAIN || '',
          secureDomain: envs.NEXT_PUBLIC_SECURE_DOMAIN || '',
          cookieDomain:
            envs.COOKIE_DOMAIN || envs.NEXT_PUBLIC_COOKIE_DOMAIN || '',
          bffBaseUrl: envs.NEXT_PUBLIC_BFF_API || '',
          apiGatewayBaseUrl: envs.NEXT_PUBLIC_API_GATEWAY_URL || '',
          cacheTime: envs.NEXT_PUBLIC_CORE_LAYOUT_CACHE_TIME || '5h',
          store: envs.NEXT_PUBLIC_STORE || 'dafiti-br',
          ...props.options,
          // TODO: remover os fallbacks de URL abaixo quando o Argo Rollouts
          // estiver disponível em live. Hoje não há como validar em live sem
          // enviar a aplicação para 100% dos usuários; sem os fallbacks, a
          // ausência de qualquer NEXT_PUBLIC_*_URL quebraria o app para todos.
          urls: {
            login: envs.NEXT_PUBLIC_LOGIN_URL || '/login',
            customer: envs.NEXT_PUBLIC_CUSTOMER_URL || '/customer/account/home',
            coupons: envs.NEXT_PUBLIC_COUPONS_URL || '/meus-cupons',
            cart: envs.NEXT_PUBLIC_CART_URL || '/cart',
            wishlist: envs.NEXT_PUBLIC_WISHLIST_URL || '/meus-favoritos',
            logout: envs.NEXT_PUBLIC_LOGOUT_URL || '/logout',
            help: envs.NEXT_PUBLIC_HELP_URL || '/atendimento',
            ...props.options.urls,
          },
        }}
      >
        {children}
      </AppLayout>
    )
  }
}
